Array.prototype.sortByProperty = function (property) {
    return this.sort.call(this, (a, b) => {
        if (a[property] < b[property]) return -1
        if (a[property] > b[property]) return 1
        return 0
    })
}